import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import {copyManualIdToClipboard, handleManualClick} from "../../utils/manualFinderUtils";
import {IManualModel} from "../../types/manualFinder";
import {useTranslation} from "react-i18next";
import {LimitedBadges} from "../../components";

interface ManualRowProps {
    manual: IManualModel;
    setIsLoading: (loading: boolean) => void;
}

const ManualRow: React.FC<ManualRowProps> = ({manual, setIsLoading}) => {
    const {t} = useTranslation();

    return (
        <tr>
            <td>
                <div
                    className="d-flex gap-2"
                    onDoubleClick={() => copyManualIdToClipboard(manual.manualId, `Copied: ${manual.manualId}`)}
                >
                    {manual.manualId}
                    <FontAwesomeIcon
                        icon={faCopy}
                        className="copy-icon"
                        role="button"
                        onClick={() => copyManualIdToClipboard(manual.manualId, `Copied: ${manual.manualId}`)}
                    />
                </div>
            </td>
            <td>{manual.itemMpText}</td>
            <td>
               <span className="hyper-link" onClick={() => handleManualClick(manual.manualId, setIsLoading, t)}>
                    {manual.manualName}
                </span>
            </td>
            <td><LimitedBadges tools={manual.matchedTools} labelClass="matched-tool-label"/></td>
            <td><LimitedBadges tools={manual.additionalTools} labelClass="additional-tool-label"/></td>
            <td><LimitedBadges tools={manual.missingTools} labelClass="notfound-tool-label"/></td>
        </tr>
    );
};

export default ManualRow;
